import { get, post, put } from '../utils/http'

class User {
  async getUserInfo(type = 'WECHAT') {
    const res = await get('/api/user/v1/getUserInfo', { type: type })
    if (res) {
      return res.data
    } else {
      let data = []
      data.status = 404
      return data.status
    }
  }

  async updateUserInfo(data) {
    const res = await post('/api/user/v1/update', data)
    return res.data
  }

  // 用户收藏
  async favorite(params = { type: 2, objectId: 1 }) {
    const res = await get('/api/user/v1/favor/add', params)
    return res.data
  }

  // 用户取消收藏
  async removeFavorite(params) {
    const res = await get('/api/user/v1/favor/remove', params)
    return res.data
  }

  // 收藏状态
  async favoriteStatus(params) {
    const res = await get('/api/user/v1/favor/isFavor', params)
    return res.data
  }

  // 获取书架列表 (精品课)
  async getBookshelf(params = { start: 1, limit: 20 }) {
    const res = await get(
      `/api/user/v1/favor/${params.start}/${params.limit}`,
      { type: 2 }
    )
    return res.data
  }

  // 获取书架列表 (微课)
  async getBookshelfSmall(params = { start: 1, limit: 20 }) {
    const res = await get(
      `/api/user/v1/favor/${params.start}/${params.limit}`,
      {
        type: 5
      }
    )
    return res.data
  }

  // 关注状态
  async followState(
    params = {
      followUserId: ''
    }
  ) {
    const res = await get('/api/user/v1/follow/isFollow', params)
    return res.data
  }

  // 关注
  async follow(params) {
    const res = await get('/api/user/v1/follow/add', params)
    return res.data
  }

  // 取消关注
  async unfollow(params) {
    const res = await get('/api/user/v1/follow/remove', params)
    return res.data
  }

  // 点赞状态
  async likeStatus(type, id) {
    const params = {
      type,
      id
    }
    const res = await get('/api/user/v1/zan/isZan', params)
    return res.data
  }

  // 点赞
  async like(type, objectId) {
    const params = {
      type,
      objectId
    }
    const res = await get('/api/user/v1/zan/add', params)
    return res.data
  }

  // 取消点赞
  async unlike(type, objectId) {
    const params = {
      type,
      objectId
    }
    const res = await get('/api/user/v1/zan/remove', params)
    return res.data
  }

  //评论数量 objectType, objectId
  async getCommentNum(objectType, objectId, status) {
    const params = {
      objectType,
      objectId,
      status
    }
    const res = await get('/api/content/v1/comment/count', params)
    return res.data
  }

  // 添加评论
  async comment(type, typeId, content, parentId) {
    const data = {
      type,
      typeId,
      content,
      parentId: parentId || -1
    }
    const res = await post('/api/content/v1/comment/add', data)
    return res.data
  }

  // 获取关注列表和粉丝列表
  async getRelations(
    params = {
      start: 1, //既：page
      limit: 10,
      type: 0
    }
  ) {
    const res = await get('/api/user/v1/follow/list', params)
    return res.data
  }

  //获取用户发布动态
  async getRelease(id, start, limit) {
    const params = {
      userId: id,
      page: start,
      limit: limit
    }
    const res = await get('/api/content/v1/shareMoment/list/byUser', params)
    return res.data
  }

  //获取用户发布课程
  async getUserCourseV2(userId) {
    const params = {
      userId
    }
    const res = await get('/api/content/v1/course/common/getUserCourse', params)
    return res.data
  }

  // 群主所属的省中心
  async getProBranch() {
    const res = await get('/api/user/v1/getProBranch')
    return res.data
  }

  // 手机获取用户资料
  async getUserByMobile(mobile) {
    const params = {
      mobile
    }
    const res = await get('/api/user/v1/getUserByMobile', params)
    return res.data
  }

  // 获取帮助中心分类
  async getCategoryList() {
    const res = await get('/api/public/v1/question/getCategoryList')
    return res.data
  }

  // 获取帮助中心主要内容
  async getQuestionById(id) {
    const params = {
      id: id
    }
    const res = await get('/api/public/v1/question/getQuestionById', params)
    return res.data
  }

  // 获取课程老师信息
  async getCourseAuthor(userId) {
    const params = {
      userId: userId
    }
    const res = await get('/api/user/v1/getCourseAuthor', params)
    return res.data
  }

  // 获取关注列表和粉丝列表-版本2
  async getFollowsOrFans(
    params = {
      userId: '', //既：page
      type: 0, //1: 关注列表 2:粉丝列表
      limit: 10,
      start: 1 //页码
    }
  ) {
    const res = await get('/api/user/v1/follow/getFollowAndFans', params)
    return res.data
  }

  // 关注状态-版本2（0: 未关注 1:已关注 2:相互关注 3:其他状态 	）
  async followStateV2(
    params = {
      other: '' //userId
    }
  ) {
    const res = await get('/api/user/v1/follow/followStatus', params)
    return res.data
  }

  // 注销用户账号
  async userLogOut() {
    const res = await put('/api/user/v1/userLogOut')
    return res
  }

  // 获取专家导师用户特训营列表
  async getUserSeminar(params) {
    const res = await get(
      '/api/content/v1/course/common/getUserSeminar',
      params
    )
    return res
  }
  // 阅读合伙人协议
  async changePartnerProtocol(data) {
    const res = await post(
      '/api/user/v1/offline/partner/changePartnerProtocol',
      data
    )
    return res.data
  }
  // 查看绑定合伙人功能是否开放
  async getPartnerFunction(params) {
    const res = await get('/api/user/v1/open/getFunctions', params)
    return res
  }
  // 获取用户隐私清单
  async getUserPrivacyList() {
    const res = await get('/api/user/v1/getUserPrivacyList')
    return res.data
  }
  // 获取置灰配置
  async getTurnGreyConfig() {
    const res = await get(
      '/api/marketing/v1/appConfig/turnGrey/getTurnGreyConfig'
    )
    return res.data
  }
  async inviteSharerBind(data) {
    const res = await post(
      '/api/user/wxvideo/shop/sharer/inviteSharerBind',
      data
    )
    return res.data
  }
  // 获取我的收藏
  async favorList(page, limit, type) {
    const res = await get(`/api/user/v1/favor/${page}/${limit}?type=${type}`)
    return res.data
  }
  // 个人主页收藏红点
  async checkUserNewFavor() {
    const res = await get('/api/user/v1/checkUserNewFavor')
    return res.data
  }
}

export default new User()
